import { useState, useEffect, useCallback } from "react";
import TablePagination from "../components/TablePagination";
import { reservationApi } from "../api";
import * as XLSX from "xlsx";

const ReservationManager = () => {
  const [members, setMembers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);

  const paginated = filtered.slice((page - 1) * pageSize, page * pageSize);

  // if (loading)
  //   return (
  //     <div className="py-20 text-center text-gray-400 text-sm">Loading...</div>
  //   );

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [b] = await Promise.all([reservationApi.getAll()]);
      debugger;
      setMembers(Array.isArray(b) ? b : []);

      setFiltered(Array.isArray(b) ? b : []);
    } catch (err) {
      console.warn("API fetch failed:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const exportToExcel = () => {
    const exportData = members.map((member) => ({
      Name: member.name,
      Email: member.email,
      "Reservation Date": member.date,
      Pax: member.pax,
      Date: formatDate(member.created_at),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Reservation");

    XLSX.writeFile(
      workbook,
      `reservation_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };
  useEffect(() => {
    fetchAll();
  }, []);

  return (
    <div className="hobmembers-page">
      <div className="hobmembers-header">
        <div>
          <h2 className="hobmembers-title">Reservations</h2>
          <p className="hobmembers-count">
            {members.length} total reservations
          </p>
          <button onClick={exportToExcel} className="export-btn">
            Export to Excel
          </button>
        </div>
      </div>

      {/* <div className="hobmembers-filter">
        <input
          type="text"
          placeholder="Search members..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          className="hobmembers-search"
        />
      </div> */}

      <div className="hobmembers-card">
        {filtered.length === 0 ? (
          <div className="hobmembers-empty">No reservation found.</div>
        ) : (
          <div className="hobmembers-table-wrap">
            <table className="hobmembers-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Reservation Date</th>
                  <th>Pax</th>
                  <th>Request</th>
                  <th>Request Date</th>
                </tr>
              </thead>
              <tbody>
                {paginated.map((member) => (
                  <tr key={member.id}>
                    <td>{member.name}</td>
                    <td>{member.email}</td>
                    <td>{member.date}</td>
                    <td>{member.pax}</td>
                    <td>{member.request}</td>
                    <td>{formatDate(member.created_at) || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <TablePagination
              total={filtered.length}
              page={page}
              pageSize={pageSize}
              onPage={setPage}
              onPageSize={setPageSize}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReservationManager;

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
